import React, { useState, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import './ClientContent.css';

import { useEffect } from 'react';

const Clientcontent = ({ ClientContentData }) => {
  const myref = useRef(null);

  useEffect(() => {
    // scrolling to client
    // window.scrollTo(0, myref.current.offsetTop);
    // window.scrollY(250)
  }, []);

  const [readMoreClicked, setReadMoreClicked] = useState(false);
  const [content, setContent] = useState({});

  const readMoreHandler = (id) => {
    if (readMoreClicked === id) {
      return setReadMoreClicked(null);
    }
    const Contentdata = ClientContentData.find((data) => data.id === id);
    setContent(Contentdata);
    setReadMoreClicked(id);
  };

  return (
    <div style={{ marginTop: 70 }}>
      <div className="bg" ref={myref}>
        <span className="Clientheading" id="ourclients">
          CLIENT
        </span>
        {/* <div className="ContentSection"> */}
        <div className="bg" style={{ marginTop: 13 }}>
          <div className="handleitems">
            {ClientContentData.map((data, index) => (
              <div
                key={index}
                className="bg-white border border-dark showcase_item p-4"
              >
                <div className="showcase_item__content">
                  <h3 className="title">{data.title}</h3>
                  <p className="showcase_item_body" id="show_items">
                    {content.id === data.id && readMoreClicked ? (
                      <ReactMarkdown>{content.article}</ReactMarkdown>
                    ) : (
                      <>
                        <div
                          style={{ fontStyle: 'italic', fontWeight: 'bold' }}
                        >
                          <p>Keywords: {data.keywords}</p>
                          <p>
                            ID: {data.ID} <span>Deadline: {data.Deadline}</span>{' '}
                          </p>
                          <p>Duration: {data.Duration}</p>
                          <p>Info: {data.info}</p>
                        </div>
                      </>
                    )}
                  </p>
                  <div
                    onClick={() => readMoreHandler(data.id)}
                    className="link"
                    style={{ color: 'black', cursor: 'pointer' }}
                  >
                    Read {readMoreClicked === data.id ? 'Less' : 'More'}
                    {/* {content.id === data.id && readMoreClicked.id ? "Less" : "More"} */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clientcontent;
